var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconeorientation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_21);}.cls-3,.cls-8{fill:#fff;}.cls-4{opacity:0.07;}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_47);}.cls-6{fill:url(#radial-gradient);}.cls-17,.cls-19,.cls-7{opacity:0.5;}.cls-8{mix-blend-mode:overlay;}.cls-9{fill:#21bbee;}.cls-10{fill:url(#linear-gradient);}.cls-11{fill:url(#linear-gradient-2);}.cls-12{fill:url(#linear-gradient-3);}.cls-13{fill:url(#linear-gradient-4);}.cls-14{opacity:0.04;}.cls-15,.cls-17{fill:#bcbec0;}.cls-16{fill:url(#linear-gradient-5);}.cls-17,.cls-19{mix-blend-mode:screen;}.cls-18,.cls-19{fill:#17243f;}.cls-20{opacity:0.1;}.cls-21{fill:#939598;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_21",
    cx: 136.01,
    cy: -159.45,
    r: 449.9,
    gradientTransform: "matrix(0.07, 0.16, -0.16, 0.07, 43.58, 30.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#8edaef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#81d6ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5fcae7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#29b7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0badd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#21bbee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#21bbee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#29bdee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3dc3ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#60cdef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8edaef"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_47",
    cx: 159.07,
    cy: -154.22,
    r: 456.08,
    gradientTransform: "translate(32.92 32.92) scale(0.18 0.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#17243f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#17243f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#17243f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#17243f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#162647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#132c59"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 51.58,
    cy: 24.29,
    r: 44.27,
    gradientTransform: "translate(32.92 32.92) scale(0.18 0.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#575753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#4c4a46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#35312d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#24201c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#231f1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1c1914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#24201c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#383530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44403c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 39.24,
    y1: 14.47,
    x2: 42.02,
    y2: 14.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#e2e8e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#cbcfc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#a9ada6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 64.77,
    y1: 40.53,
    x2: 67.05,
    y2: 40.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 12.93,
    y1: 40.53,
    x2: 17.2,
    y2: 40.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 39.31,
    y1: 66.15,
    x2: 41.96,
    y2: 66.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 41.41,
    y1: 57.47,
    x2: 44.03,
    y2: 57.47,
    gradientTransform: "matrix(1.86, 0, 0, 1, -36.47, -5.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e7f7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#787975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#696967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505052"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(-12.83 60.23) rotate(-65.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 40.08,
    cy: 40.05,
    r: 33.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 40,
    cy: 40,
    r: 32.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 40,
    cy: 40,
    r: 29.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 40,
    cy: 40,
    r: 4.49
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M36.85,77.43A41.85,41.85,0,0,1,3.22,55.08a39.67,39.67,0,0,0,70.43,5.76A41.61,41.61,0,0,1,36.85,77.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M51.79,3.73c-14-4.68-28.91-.73-39.85,8.1A39.68,39.68,0,0,1,79,34.15C76,21,65.85,8.41,51.79,3.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18.11,23.9l18,39.68h9.09l18-40H18Zm35.16,5.68L41.14,57.39h-1L27.82,29.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.55,40.22h0l-.06,0L44.69,36.26l-3.92-18.8s0,0,0,0l0,0,0,0,0,0h0l0,0,0,0,0,.05s0,0,0,0l-3.92,18.8-18.8,3.93,0,0,0,0a.08.08,0,0,0,0,.05s0,0,0,0h0v0l0,0a.05.05,0,0,0,0,0s0,0,0,0l0,0,18.8,3.92,3.92,18.8s0,0,0,0l0,0s0,0,.06,0h.08s0,0,0,0l0,0,0,0,3.92-18.79,18.8-3.93,0,0s0,0,0,0v0a.15.15,0,0,0,0-.07A.15.15,0,0,0,63.55,40.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.68,29.17h0l-11,7.2-11-7.2H29.5s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0l7.2,11-7.2,11s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h.13l11-7.2,11,7.2h.13v0s0,0,0,0a0,0,0,0,0,0,0v0l-7.21-11,7.21-11v0a.08.08,0,0,0,0,0h0s0,0,0-.05A.11.11,0,0,0,51.68,29.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M39.24,12.69h.82L41,14.46l.36.78h0c0-.38-.1-.88-.1-1.3V12.69H42v3.55H41.2l-.93-1.77-.35-.77h0c0,.39.11.86.11,1.28v1.26h-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M64.77,38.76H67v.68H65.57v.71h1.21v.67H65.57v.81h1.48v.68H64.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M12.93,38.76h.82L14,40.42l.15,1.12h0c.06-.37.14-.75.21-1.12l.38-1.66h.68l.38,1.66c.07.36.14.74.21,1.12h0c.05-.38.1-.76.15-1.12l.24-1.66h.77l-.63,3.55h-1l-.35-1.61c-.05-.27-.1-.56-.14-.82h0c0,.26-.09.55-.14.82l-.34,1.61h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M39.77,66.93a1.4,1.4,0,0,0,.87.37c.33,0,.49-.13.49-.34s-.2-.29-.51-.42l-.45-.2a1,1,0,0,1-.72-1,1.15,1.15,0,0,1,1.26-1.05,1.6,1.6,0,0,1,1.14.47l-.4.5a1.16,1.16,0,0,0-.74-.28c-.27,0-.45.12-.45.32s.23.29.54.42l.45.18a1,1,0,0,1,.71,1c0,.59-.49,1.1-1.34,1.1a1.93,1.93,0,0,1-1.31-.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "45.42 40.1 40.55 44.92 40.52 44.92 40.53 16.63 45.41 40.03 45.42 40.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "45.42 40.1 40.55 44.92 40.52 44.92 40.53 16.63 45.41 40.03 45.42 40.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "40.53 16.63 40.52 44.92 40.49 44.92 35.64 40.05 35.64 40.03 40.53 16.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "40.53 39.98 40.52 63.42 35.64 40.01 35.64 39.98 40.52 39.98 40.53 39.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "45.4 40.05 40.52 63.42 40.53 39.98 45.37 40.02 45.4 40.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "45.4 40.05 40.52 63.42 40.53 39.98 45.37 40.02 45.4 40.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.16,41.17a3,3,0,0,1-3.84,1.36,2.7,2.7,0,0,1-1.42-3.66,3,3,0,0,1,3.83-1.36A2.71,2.71,0,0,1,43.16,41.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M42.71,41a2.46,2.46,0,0,1-3.18,1.13,2.25,2.25,0,0,1-1.19-3,2.46,2.46,0,0,1,3.19-1.13A2.24,2.24,0,0,1,42.71,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M42.65,41a2.38,2.38,0,0,1-3.09,1.1,2.2,2.2,0,0,1-1.16-3A2.38,2.38,0,0,1,41.5,38,2.17,2.17,0,0,1,42.65,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M42.65,41a2.38,2.38,0,0,1-3.09,1.1,2.2,2.2,0,0,1-1.16-3A2.38,2.38,0,0,1,41.5,38,2.17,2.17,0,0,1,42.65,41Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M57.11,16.3a29.19,29.19,0,0,0-40.86,6.78,29.52,29.52,0,0,0,7,41,29.19,29.19,0,0,0,40.86-6.78A29.51,29.51,0,0,0,57.11,16.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M69.46,40,12.39,49.49a29.73,29.73,0,0,1-1.54-9.16L67.9,30.86A29.41,29.41,0,0,1,69.46,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M66.94,28.37l-56,9.29a29,29,0,0,1,.61-4L65,24.77A30.21,30.21,0,0,1,66.94,28.37Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeorientation);
export default __webpack_public_path__ + "static/media/ICONE ORIENTATION.0ee9d65a71765ef224dddb0c7f75b3c6.svg";
export { ForwardRef as ReactComponent };